T.EveryPayMobile = Class(
    /**
     * @lends {T.EveryPayMobile#}
     */
    {
        paymentMethod: null,
        paymentId: null,

        paymentData: null,

        __construct(par) {
            par = par || {};
            this.paymentMethod = par.paymentMethod;
            this.paymentId = par.paymentId;

            this.node = mkE({
                tag: 'div',
                id: 'every-pay-mobile'
            });

            let availableMethods = [
                'apple-pay',
                'google-pay',
            ];

            if (!availableMethods.includes(this.paymentMethod)) {
                return;
            }

            this._loadData(par.apiCall || null);
        },

        draw() {
            this._drawPaymentInformation();
        },

        _loadData(apiCall) {
            this._mGetPaymentInformation = new DR.services.GetPaymentInformation();
            this._mGetPaymentInformation.paymentId = this.paymentId;
            this._mGetPaymentInformation.onLoad = this._onPaymentInformation;
            this._mGetPaymentInformation.onError = this._onPaymentError;
            if (apiCall) {
                apiCall.addMethod(this._mGetPaymentInformation);
            } else {
                this._mGetPaymentInformation.call();
            }
        },

        _onPaymentInformation() {
            this.paymentData = this._mGetPaymentInformation.re;
        },

        _onPaymentError() {
            D.sendPostMessage({
                status: 'error',
                message: 'Failed to get payment information',
            });
        },

        _drawPaymentInformation() {
            mkE({
                tag: 'div',
                className: 'amount',
                els: [
                    {
                        tag: 'div',
                        text: D.Lang.get('profile.team.purchase.totalAmount'),
                    },
                    {
                        tag: 'div',
                        className: 'h4',
                        text: '€' + ((this.paymentData.price) / 100).toFixed(2)
                    }
                ]
            }).append(this.node);

            switch (this.paymentMethod) {
                case 'apple-pay':
                    if (!window.ApplePaySession || !ApplePaySession.canMakePayments()) {
                        D.sendPostMessage({
                            status: 'error',
                            message: 'Unsupported device',
                        });
                        return;
                    }
                    D.onApplePay(() => {
                        this._drawApplePay();
                    });
                    return;
                case 'google-pay':
                    D.onEveryPayGooglePayClient(() => {
                        this._drawGooglePlay();
                    });
                    return;
            }
        },

        _drawApplePay() {
            mkE({
                tag: 'apple-pay-button',
                attr: {
                    buttonstyle: 'black',
                    type: 'pay',
                    locale: 'en-US',
                },
                onclick: this._getEveryPayData
            }).append(this.node);
        },

        _payWithApple() {
            D.everyPayApplePayClient(() => {
                this._applePayClient = ApplePayClient.initialize({
                    access_token: this.everyPayData.mobileToken,
                    api_username: this.everyPayData.apiUsername,
                    merchant_id: this.everyPayData.applePayMerchantIdentifier,
                    account_name: this.everyPayData.accountName,
                });
                this._applePayClient.createApplePayPayment({
                    payment_reference: this.everyPayData.paymentReference,
                    country_code: this.everyPayData.descriptorCountry,
                    currency_code: this.everyPayData.currency,
                    payment_link: this.everyPayData.paymentLink,
                    total: {
                        label: this.everyPayData.label,
                        amount: this.everyPayData.amount / 100
                    }
                });
            });
        },

        _drawGooglePlay() {
            this._googlePayClient = GooglePayClient.initialize({
                testEnv: D.DEV
            });
            let paymentsClient = this._googlePayClient._paymentsClient;
            let baseParams = {
                "apiVersion": 2,
                "apiVersionMinor": 0
            };
            let allowedPaymentMethods = {
                "type": "CARD",
                "parameters": {
                    "allowedAuthMethods": [
                        "PAN_ONLY",
                        "CRYPTOGRAM_3DS"
                    ],
                    "allowedCardNetworks": [
                        "MASTERCARD",
                        "VISA"
                    ]
                }
            }
            paymentsClient.isReadyToPay(Object.assign({}, baseParams, {
                allowedPaymentMethods: [allowedPaymentMethods]
            })).then(t => {
                if (t.result) {
                    const t = paymentsClient.createButton({
                        buttonColor: 'black',
                        buttonType: 'pay',
                        buttonSizeMode: 'fill',
                        onClick: this._getEveryPayData,
                    });
                    let googlePayContainer = mkE({
                        tag: 'div',
                        className: 'google-pay-container'
                    }).append(this.node);
                    googlePayContainer.appendChild(t)
                } else {
                    D.sendPostMessage({
                        status: 'error',
                        message: 'Unsupported device',
                    });
                }
            }).catch((e) => {console.error(e);});
        },

        _payWithGooglePay() {
            const googleClientData = {
                access_token: this.everyPayData.mobileToken,
                api_username: this.everyPayData.apiUsername,
                account_name: this.everyPayData.accountName,
                payment_reference: this.everyPayData.paymentReference,
                country_code: this.everyPayData.descriptorCountry,
                currency_code: this.everyPayData.currency,
                payment_link: this.everyPayData.paymentLink,
                amount: `${this.everyPayData.amount / 100}`,
            }
            this._googlePayClient.configure(googleClientData);
            this._googlePayClient.createGooglePayPayment();
        },

        _getEveryPayData() {
            if (this._gettingData) {
                if (this.everyPayData) {
                    switch (this.paymentMethod) {
                        case 'apple-pay':
                            this._payWithApple();
                            return;
                        case 'google-pay':
                            this._payWithGooglePay();
                            return;
                    }
                }
                return;
            }
            this._gettingData = true;

            this._mGetEveryPayData = new DR.services.GetEveryPayData();
            this._mGetEveryPayData.paymentId = this.paymentId;
            this._mGetEveryPayData.selectedPaymentMethod = this.paymentMethod;
            this._mGetEveryPayData.isWebview = true;
            this._mGetEveryPayData.onLoad = () => {
                this.everyPayData = this._mGetEveryPayData.re;
                switch (this.paymentMethod) {
                    case 'apple-pay':
                        this._payWithApple();
                        return;
                    case 'google-pay':
                        this._payWithGooglePay();
                        return;
                }
                this._gettingData = false;
            };
            this._mGetEveryPayData.onError = () => {
                D.sendPostMessage({
                    status: 'error',
                    message: 'Failed to get data',
                });
            };
            this._mGetEveryPayData.call();
        },
    },
    mkE.Base
);
